//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myQaQuestionAction from '../action/myQaQuestionAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';
//Add
import moment from 'moment';
//Menu
import MenuMyQa from './MenuMyQa';
//Part
import MenuMyProfile from './MenuMyProfile';
import PartPagingNextPrev from './PartPagingNextPrev';
import PartMyQaQuestionStatistics from './PartMyQaQuestionStatistics';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';


class Comp extends React.Component {

  constructor(props) {
		super(props);
    this.state = {
      qaDelId: null,
    }
	}

  componentDidMount() {
    document.title = 'Q&A(質問) - パートナーズ';
    if ( ((new Date()) - this.props.my.qaQuestion.datetime) > (86400*1000) ) {
      this.props.myQaQuestionListGet(1);
    }
    if (this.props.history.action === 'PUSH') {
      window.scrollTo(0, 0);
    }
  }

  _answerStatisticsToggle(qaId) {
    let index = this.props.my.qaQuestion.list.findIndex((v) => v.qa_id === qaId);
    if (this.props.my.qaQuestion.list[index].statistics) {
      this.props.myQaQuestionStatisticsDel(qaId);
    }
    else {
      this.props.myQaQuestionStatisticsGet(qaId);
    }
  }


  _renderList(value, index) {
    let checkIcon;
    if (value.qa_webmaster_check === 0) {
    	checkIcon = (<span className='purple_icon'>申請中</span>);
    }
    else if (value.qa_webmaster_check === 1) {
    	checkIcon = (<span className='orange_icon'>公開中</span>);
    }
    else if (value.qa_webmaster_check === 2) {
    	checkIcon = (<span className='black_icon'>不承認</span>);
    }
    else if (value.qa_webmaster_check === 3) {
    	checkIcon = (<span className='blue_icon'>未申請</span>);
    }

    let listOpenIcon;
    if (value.qa_list_open === 1) {
      listOpenIcon = (<span className='white_icon'>みんなのQ&A & プロフ</span>);
    }
    else if (value.qa_list_open === 0) {
      listOpenIcon = (<span className='white_icon'>プロフ</span>);
    }

    return (
      <div key={index} style={{margin:'15px'}}>
        <Box className='postItem round12' boxShadow={2} style={{background:'#FFF'}}>
          <div style={{padding:'10px'}}>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}>
              <div>
                {
                  (moment(value.qa_date).isValid()) && (
                    moment(value.qa_date).format("YYYY年MM月DD日")
                  )
                }
              </div>

              <div>
                <IconButton
                  onClick={ () => this.props.history.push('/my/qa/question/' + value.qa_id) }
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  onClick={ () => this.setState({qaDelId: value.qa_id}) }
                >
                  <ClearIcon />
                </IconButton>
              </div>
            </div>
            {checkIcon} {listOpenIcon}
            <div style={{padding:'5px', fontSize:'1.1em', whiteSpace: 'pre-line'}}>
              { value.qa_question }
            </div>
            {
  						(Array.isArray(value.qa_answer) === true) &&
  						value.qa_answer.map(
  							(answerValue, answerIndex, arr) => this._renderAnswer(answerValue, answerIndex, arr)
  						)
  					}
            <div style={{margin:'10px'}} align='center'>
              {
                (value.qa_answer_count > 0) ? (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={ () => this._answerStatisticsToggle(value.qa_id) }
                  >
                    回答 { value.qa_answer_count }件
                  </Button>
                ) : (
                  <span style={{color:'#666'}}>回答はまだありません</span>
                )
              }

            </div>
            <div>
              {
                (value.statistics) &&
                <PartMyQaQuestionStatistics
                  qaId={value.qa_id}
                  statistics={value.statistics}
                />
              }
            </div>
          </div>

        </Box>
      </div>
    )
  }




  _renderAnswer(value, index, qa_id) {
		return (
			<div key={index} style={{margin:'5px'}}>
        <Button
          size="large"
          variant="outlined"
          style={{textAlign:'left', textTransform: 'none'}}
        >
          { value }
        </Button>

			</div>
		);
	}

  _onPaging(page) {
    this.props.myQaQuestionListGet(page);
    window.scrollTo(0, 0);
  }

  _qaDelSubmit(qaId) {
    this.props.myQaQuestionItemDel(qaId);
    this.setState({qaDelId: null});
  }

  render() {
    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <MenuMyProfile />

        <MenuMyQa />

        {
          (this.props.my.qaQuestion.count < this.props.config.qaQuestionLimit) && (
            <div style={{textAlign:'center'}}>
              <Fab
                variant="extended"
                color="primary"
                onClick={ () => this.props.history.push('/my/qa/question/add') }
              >
                <AddIcon />
                Q&Aを作成する
              </Fab>
            </div>
          )
        }



        {
          (this.props.my.qaQuestion.datetime) && (
            <div id='my_post_block'>
            {
              (this.props.my.qaQuestion.list.length > 0) ? (
                <div>
                  <div
                    style={{
                      display:'flex',
                      flexDirection:'row',
                      alignItems:'center',
                      justifyContent: 'space-between',
                      margin: '10px',
                    }}
                  >
                    <div>
                      { this.props.my.qaQuestion.count } / {this.props.config.qaQuestionLimit}件 (公開中 { this.props.my.qaQuestion.countOpen }件)
                    </div>
                    <div>
                      <span style={{color:'#666'}}>ページ{this.props.my.qaQuestion.page}</span>
                      <IconButton
                        onClick={ () => this.props.myQaQuestionListGet(1) }
                      >
                        <RefreshIcon />
                      </IconButton>
                    </div>
                  </div>
                  {
                    this.props.my.qaQuestion.list.map((value, index) =>
                      this._renderList(value, index)
                    )
                  }

                  <div style={{margin:'15px'}}>
                    <PartPagingNextPrev
                      page={this.props.my.qaQuestion.page}
                      isNext={this.props.my.qaQuestion.isListNext}
                      onClick={ (e) => this._onPaging(e) }
                    />
                  </div>
                </div>
              ):(
                <div style={{padding:'10px'}}>
                  <h2 align='center' style={{margin:'5px'}}>
                    Q&Aは作成されていません
                  </h2>
                  <div align='center' style={{margin:'5px'}}>
                    パートナーに聞きたい質問を<br />
                    <span
                    className='link'
                      onClick={ () => this.props.history.push('/community/qa/') }
                    >
                      <u>みんなのQ＆A</u>
                    </span>
                    やプロフィールに掲載できます。<br />
                    事前に確認しておきたいことや<br />
                    メールでは聞きづらいことなどを<br />
                    一問一答の選択形式で<br />
                    質問することができます。
                  </div>
                </div>
              )
            }
            </div>
          )
        }

        <DialogConfirm
          open={ (this.state.qaDelId) ? true : false }
          title={'Q&Aの削除'}
          content={'Q&Aから1件削除してもいいですか？'}
          apply={ () => this._qaDelSubmit(this.state.qaDelId) }
          close={ () => this.setState({qaDelId: null}) }
        />

      </div>

    )

  }
}


const mapStateToProps = (state) => {
	return {
    config: state.config,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myQaQuestionAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
